import api from '..'

const downloadLmsProfiles = () => {
  return api.get('administration/lms_profiles/download')
}

export default downloadLmsProfiles
